import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import moment from 'moment'
import VueAnalytics from 'vue-analytics'

import router from './routes' 
import messages from './locales'

Vue.use(VueAnalytics, {
  id: 'UA-111283719-1',
  router,
  autoTracking: {
    pageviewOnLoad: true
  }
})

Vue.use(VueI18n)
Vue.use(BootstrapVue)

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('L')
  }
})
Vue.filter('formatHour', function(value) {
  if (value) {
    return moment(String(value)).format('LT')
  }
})
moment.locale(localStorage.getItem('language')
                || navigator.languages.find((l) => l.length == 2)
                || navigator.language.split('-')[0]
                || 'fr');

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: localStorage.getItem('language')
    || navigator.languages.find((l) => l.length == 2)
    || navigator.language.split('-')[0]
    || 'fr',
  messages
})

if(navigator.language.indexOf("fr") == -1){
  i18n.locale = 'en'
}

new Vue({
  render: h => h(App),
  i18n,
  router
}).$mount('#app')
